// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.equipment-detail .status-selector label,\n.equipment-detail .status-selector-text {\n  margin-left: 0;\n}\n.equipment-detail .status-selector-text {\n  margin: -14px 0 0 0 !important;\n  font-size: 12px;\n}\n.serial-number {\n  float: left;\n  width: 100%;\n  clear: both;\n  font-size: 0.875rem;\n  font-weight: 500;\n  line-height: 1.375rem;\n  letter-spacing: 0.00714em;\n  margin: 10px 0 0 0;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
